import React, { FC } from "react";

import { ReactComponent as User } from "../../assets/icons/16x16/user.svg";

import { BadgeProps } from "./Badge.types";
import styles from "./Badge.module.scss";

const Badge: FC<BadgeProps> = ({
    item: { background_color, border_color, text_color, name },
    handleClick,
    checked,
}) => {
    return (
        <button
            onClick={handleClick}
            style={{
                color: checked ? text_color : "#344054",
                border: checked ? `1px solid ${border_color}` : "1px solid #EAECF0",
                background: checked ? background_color : undefined,
            }}
            className={`${styles.button} ${checked ? styles.checked : styles.normal}`}
        >
            <User style={{ color: checked ? text_color : "#344054" }} />
            <span className={styles.text}>{name}</span>
        </button>
    );
};

export default Badge;
